<template>
    <div>
        <div name="confHeader" style="width:100%; height: 34px; line-height: 30px;padding-left : 10px; font-size: 14px; background-color: #EFEFEF ">
            {{ title || '结果列设置' }}
            <span v-if="!viewMode" class="ml10">
                <el-link v-if="userMode ==0" type="danger" class="ml20" style="padding-bottom:2px;font-size:13px;" size="mini" @click="clearMetaCols()">清除所有字段</el-link>
                <el-link v-if="userMode ==0" type="primary" class="ml20 mr20" style="padding-bottom:2px;font-size:13px;" size="mini" @click="addMetaCol()">+ 追加字段</el-link>
                <el-divider v-if="userMode ==0" direction="vertical"></el-divider>
                <el-link v-if="userMode <2" type="primary" class="ml20 mr10" title="把固定列按未来结果排在最前面" style="padding-bottom:2px;font-size:13px;" size="mini" @click="bttopFixedCols()">固定列置于前</el-link>
            </span>
            <span v-if="userMode ==2 && !viewMode" class="fr mr5">
                <el-link type="primary" class="ml20 mr10" title="把固定列按未来结果排在最前面" style="padding-bottom:2px;font-size:13px;" size="mini" @click="bttopFixedCols()">固定列置于前</el-link>
                <span v-if="showExtBtns" class="ml30 mr5">
                    <el-button v-if="custSavable && onSaveCustConf != null" @click="handleSaveCustConf()" size="mini" icon="el-icon-document-checked" style="margin-top: 1px;" title="保存个性调整">保存调整</el-button>
                    <el-divider v-if="custSavable && onSaveCustConf != null" direction="vertical"></el-divider>
                    <el-button @click="handleConfirm()" size="mini" icon="el-icon-check" style="margin-top: 1px;" title="应用列调整">应用</el-button>
                    <a @click="handleClose()" title="取消/关闭" class="ml20" style="width:30px;height:30px;text-align: center;vertical-align: middle">
                        <i class="el-icon-close" style="font-size : 18px; "></i>
                    </a>
                </span>
            </span>
            <span v-if="userMode <2 && !viewMode" class="fr mr5">
                <span v-if="userMode == 0">
                    <el-input size="mini" v-model="instantKeyword" class="mr10" placeholder="输入 过滤文本" style="width:100px;" clearable @change="filterList"></el-input>
                    <el-divider direction="vertical"></el-divider>
                    <span v-if="forHisQry">
                        <el-link type="primary" class="ml10 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" icon="el-icon-notebook-2" @click="appendFromCols()">从表列选择</el-link>
                        <el-divider direction="vertical"></el-divider>
                    </span>
                    <el-link type="primary" class="ml10 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" icon="el-icon-document" title="meta colList" @click="inputJsonConf()">输入json配置</el-link>
                    <el-divider v-if="onPreviewConf != null" direction="vertical"></el-divider>
                </span>
                <el-link v-if="userMode <2 && onPreviewConf != null" type="primary" class="ml10 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" icon="el-icon-view" @click="previewTheConf()">预览当前配置</el-link>
            </span>
        </div>
        <!-- 动态标签弹出框 -->
        <swb-dt-popover ref="dynaTagPopover" :disabled="userMode !=0" v-model="dynaTagEditorVisible" @show="syncDynaTagEditorVisible(true)" @hide="syncDynaTagEditorVisible(false)">
            <swb-prop-editor :title="dynaTagEditor.title" :showBtnBar="dynaTagEditor.showBtnBar" :width="dynaTagEditor.width" :widthForLabel="dynaTagEditor.widthForLabel" :propList="dynaTagEditor.propList" :extra="dynaTagEditor.extra"
                             :viewMode="dynaTagEditor.viewMode" :readOnly="dynaTagEditor.readOnly" :onConfirm="onDynaTagEditorConfirm" :onCancel="onDynaTagEditorCancel"></swb-prop-editor>
        </swb-dt-popover>
        <!-- 结果列提示设置弹出框 -->
        <swb-dt-popover ref="colTipPopover" :title="'列头提示信息'" :disabled="userMode >1">
            <div>
                <el-input type="textarea" v-model="curColTooltip" style="width:400px;" :maxlength="colTipMaxLength" :autosize="colTipAutoSize"></el-input>
                <div style="width:100%;height:50px; padding:14px 4px;">
                    <el-button style="margin-left: 130px;" @click="doColTipCancel()">取 消</el-button>
                    <el-button style="margin-left: 30px;" @click="doColTipConfirm()">确 定</el-button>
                </div>
            </div>
        </swb-dt-popover>
        <!-- 结果列枚举设置弹出框 -->
        <swb-dt-popover ref="enumMapPopover" :title="'列值枚举信息'" :disabled="userMode >0">
            <div>
                <el-input type="text" placeholder="格式：name, type，比如 assetNature, value2text" v-model="curEnumMap" clearable style="width:360px;" :maxlength="60"></el-input>
                <div style="width:100%;height:50px; padding:14px 4px;">
                    <el-button style="margin-left: 130px;" @click="doEnumMapCancel()">取 消</el-button>
                    <el-button style="margin-left: 30px;" @click="doEnumMapConfirm()">确 定</el-button>
                </div>
            </div>
        </swb-dt-popover>
        <el-form name="confForm" ref="tableForm" class="result-col-form" :model="formData">
            <el-table ref="gridTable" :data="formData.colConfRows" v-row-draggable="makeDragCtxData()" :row-class-name="getTableRowClassName" :row-key="rowItemKey" stripe highlight-current-row size="mini" :height="gridHeight"
                      style="width: 100%; min-width:560px;">
                <el-table-column label="序号" width="60" align="center" type="index" fixed></el-table-column>
                <el-table-column v-if="userMode == 0" label="名称/代码" width="120" fixed>
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'colConfRows[' + scope.$index + '].name'">
                            <el-input maxlength="30" class="col-name" v-model="scope.row.name" size="mini"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="默认标题" width="100" fixed>
                    <template slot-scope="scope">
                        <div class="text">
                            <el-form-item style="margin-bottom: 0" v-if="userMode == 0" :prop="'colConfRows[' + scope.$index + '].text'">
                                <el-input maxlength="20" class="col-text" v-model="scope.row.text" size="mini"/>
                            </el-form-item>
                            <div v-else-if="userMode == 1">{{ scope.row.text }}</div>
                            <div v-else>{{ scope.row.metaTitle || scope.row.text }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode > 0" label="自定义标题" width="100">
                    <template slot-scope="scope" slot="header">
                        自定义标题
                        <el-tooltip class="item" effect="dark" placement="top">
                            <span slot="content" style="line-height:30px;">
                                - 自定义标题如果与默认标题不同，则会显示绿色下划线<br/>
                                - 注意：对于 隐藏列 无效
                            </span>
                            <span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'colConfRows[' + scope.$index + '].title'">
                            <el-input maxlength="20" class="col-title" :class="{'diff' : isDiffTitle(scope.$index)}" v-model="scope.row.title" size="mini" clearable :disabled="scope.row.hidden || scope.row.dynaTag"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="合并组标题" width="100">
                    <template slot-scope="scope" slot="header">
                        合并组标题
                        <el-tooltip v-if="userMode == 2" class="item" effect="dark" placement="top">
                            <span slot="content" style="line-height:30px;">
                                - 未输入文字时的默认灰色文字为预设的合并组标题 <br/>
                                - 如果自定义的合并组标题与预设的不同，则会显示绿色下划线<br/>
                                - 提示：可以敲入英文空格让默认合并组标题失效（也即不分组）<br/>
                                - 注意：对于 隐藏列 和 固定列 无效
                            </span>
                            <span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'colConfRows[' + scope.$index + '].group'">
                            <input maxlength="20" type="text" class="col-group" :class="{'diff' : isDiffGroup(scope.$index)}" :placeholder="(scope.row.fixed || scope.row.hidden) ? '' : scope.row.metaGroup" v-model="scope.row.group"
                                   size="mini" clearable :disabled="scope.row.fixed || scope.row.hidden" style="height:28px; font-size:12px; width:90px;"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="像素宽" width="60" header-align="right">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'colConfRows[' + scope.$index + '].width'" :title="getColWidthHint()">
                            <el-input maxlength="10" class="col-width" v-model="scope.row.width" size="mini" placeholder="" @blur="filterColWidth(scope.row, scope.$index)" :disabled="scope.row.hidden"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="数据类型" width="100" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" v-if="userMode == 0" :prop="'colConfRows[' + scope.$index + '].dataType'">
                            <el-select class="col-dataType" v-model="scope.row.dataType" size="mini">
                                <el-option label="字符串" value="string"></el-option>
                                <el-option label="整  数" value="integer"></el-option>
                                <el-option label="浮点数" value="float"></el-option>
                                <el-option label="日期/时间" value="date"></el-option>
                                <el-option label="布尔/是否" value="bool"></el-option>
                            </el-select>
                        </el-form-item>
                        <div v-else="">{{ getDataTypeName(scope.row.dataType) }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="水平对齐" width="80">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'colConfRows[' + scope.$index + '].align'">
                            <el-select v-model="scope.row.align" size="mini" :disabled="scope.row.hidden">
                                <el-option label="|<---" value="left"></el-option>
                                <el-option label="->|<-" value="center"></el-option>
                                <el-option label="---->|" value="right"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode == 0" label="格式化模式" width="160" header-align="center">
                    <template slot-scope="scope">
                        <el-form-item v-if="isFormattable(scope.row.dataType)" style="margin-bottom: 0" :prop="'colConfRows[' + scope.$index + '].format'">
                            <input maxlength="20" type="text" class="col-format" :disabled="scope.row.hidden" v-model="scope.row.format" style="height:28px; font-size:12px; width:150px;"/>
                        </el-form-item>
                        <div v-else=""></div>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode ==0" label="枚举" width="50" align="center">
                    <template slot-scope="scope">
                        <el-link v-show="scope.row.dataType == 'integer'" @click="showEnumMapEditor($event, scope.$index)" :title="scope.row.enumMap">
                            <i v-if="scope.row.enumMap" style="font-size:16px;border-bottom: 1px dashed darkblue;" class="el-icon-document"></i>
                            <i v-else style="font-size:16px;;" class="el-icon-document"></i>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode <2" width="40" align="center">
                    <template slot-scope="scope" slot="header">
                        <el-tooltip class="item" effect="dark" placement="top">
                            <span slot="content" style="white-space: pre-wrap">设置列头提示说明信息</span>
                            <span><i class="el-icon-question col-title-tooltip"></i></span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-link @click="showColTipEditor($event, scope.$index)" :title="scope.row.tooltip">
                            <i v-if="scope.row.tooltip" style="font-size:16px;border-bottom: 1px dashed darkblue;" class="el-icon-chat-line-square"></i>
                            <i v-else style="font-size:16px;;" class="el-icon-chat-line-square"></i>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column label="超宽..." width="60" align="center">
                    <template slot-scope="scope">
                        <input type="checkbox" :disabled="scope.row.hidden" v-model="scope.row.overflowAsTip"/>
                    </template>
                </el-table-column>
                <el-table-column label="固定列" width="60" align="center">
                    <template slot-scope="scope">
                        <input type="checkbox" :disabled="scope.row.hidden" v-model="scope.row.fixed" @change="syncFixedColConf(scope.row, scope.$index)"/>
                    </template>
                </el-table-column>
                <el-table-column label="隐藏之" width="60" align="center">
                    <template slot-scope="scope">
                        <input type="checkbox" :disabled="scope.row.secret" v-model="scope.row.hidden" @change="syncHiddenColConf(scope.row, scope.$index)"/>
                    </template>
                </el-table-column>
                <el-table-column label="报表用" width="60" align="center" v-if="userMode ==0">
                    <template slot-scope="scope">
                        <input type="checkbox" v-model="scope.row.rptUsed"/>
                    </template>
                </el-table-column>
                <el-table-column label="动态标签" width="70" align="left" v-if="userMode == 0">
                    <template slot-scope="scope">
                        <div v-show="mayBeDynaTagField(scope.row, scope.$index)">
                            <input type="checkbox" v-model="scope.row.dynaTag"/>
                            <el-link v-show="scope.row.dynaTag" style="cursor: pointer;margin-left: 8px;" @click="showDynaTagEditor($event, scope.$index)">
                                <i class="el-icon-setting" title="设置动态标签字段配置信息"></i>
                            </el-link>
                        </div>
                    </template>
                </el-table-column>
                <!-- TODO 增加 virtualFlag 虚拟列支持 -->
                <el-table-column v-if="!viewMode" label="操作/顺序" width="120" align="center">
                    <template slot-scope="scope">
                        <div>
                            <i class="icon iconfont icon-arrow-top pr10" style="cursor:pointer;" @click="moveColPosition(scope.row.name, scope.$index, 'prev')"></i>
                            <i class="icon iconfont icon-arrow-bottom pr10" style="cursor:pointer;" @click="moveColPosition(scope.row.name, scope.$index, 'next')"></i>
                            <i v-if="userMode == 0" class="icon iconfont el-icon-delete pl10 pr10" style="cursor:pointer;color:orange" @click="deleteMetaCol(scope.$index)"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode == 0 && showAsTpl" width="60" align="center">
                    <template slot-scope="scope" slot="header">
                        <el-tooltip class="item" effect="dark" placement="top" :open-delay="tooltipDelayMs">
                            <span slot="content">是否把返回的自定义列内容当作vue模板<br/><br/>以便按类似&lt;template&gt;...&lt;/template&gt;的方式渲染结果单元格内容</span>
                            <span>按模板</span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <input type="checkbox" :disabled="scope.row.hidden" v-model="scope.row.asTpl"/>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode < 2" label="私密的" width="60" align="center">
                    <template slot-scope="scope">
                        <input type="checkbox" v-model="scope.row.secret" @change="syncSecretColConf(scope.row, scope.$index)"/>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>
</template>
<script>
    // last modified by koqiui
    import {Utils, $, Jqext} from '../../app.base'
    import {Vue, MsgBox, VRowId, getColDefAlign, getColDefFormat, calcDomHeight, getElTableHeight, fixElTableFixedHeight} from '../../app.vues'

    import SwbPropEditor from '../ctrl/PropEditor.vue';
    import SwbDtPopover from '../ctrl/DtPopover.vue';

    import SwbCodeEditor from '../ctrl/CodeEditor.vue'
    import {showDbColSelectDlg} from './dialog';
    import {makeTagMetaRoleList} from './Cmn'

    Vue.regist(SwbCodeEditor);

    let Toast = Jqext.Toast;

    const dataTypeNameMap = {
        'string': '字符串',
        'integer': '整  数',
        'float': '浮点数',
        'date': '日期/时间',
        'bool': '布尔/是否'
    };

    export function extractCustColInfo(colConf) {
        return colConf == null ? null : {
            name: colConf.name,
            //
            title: colConf.title || null,
            group: colConf.group || null,
            width: Utils.ParseInt(colConf.width),
            align: colConf.align,
            overflowAsTip: colConf.overflowAsTip || false,
            hidden: colConf.hidden,
            fixed: colConf.fixed || false
        };
    }

    //保留性地合并数组元素 arr1st <= arr2nd（保留arr1st中元素的属性值）
    export function reserveMergeColArray(arr1st, arr2nd, keyProp = 'id') {
        arr1st = arr1st || [];
        arr2nd = arr2nd || [];
        let arr2Map = arr2nd.toMap(keyProp);
        //去除不存在的
        for (let i = arr1st.length - 1; i >= 0; i--) {
            let item1st = arr1st[i] || {};
            let keyValue = item1st[keyProp];
            if (typeof arr2Map[keyValue] == 'undefined') {
                arr1st.removeAt(i);//已不存在删除之
                console.log('已去除不再有效的列：' + keyProp + ' = ' + keyValue);
            }
        }
        let arrNew = [];
        for (let i = 0, c = arr1st.length; i < c; i++) {
            let item1st = extractCustColInfo(arr1st[i]) || {};
            let keyValue = item1st[keyProp];
            let item2nd = Utils.merge({}, arr2Map[keyValue]);//copy
            delete arr2Map[keyValue]; //去掉
            arrNew[i] = Utils.merge(item2nd, item1st); // item2nd + item1st
        }
        //加上剩余地
        for (let keyValue in arr2Map) {
            arrNew.push(arr2Map[keyValue]);
        }
        //
        return arrNew;
    }

    export function arrangeColList(metaColList) {//重排列（私密在后）
        metaColList = metaColList || [];
        let metaCol = null;
        let foreList = [];
        let backList = [];
        for (let i = 0, c = metaColList.length; i < c; i++) {
            metaCol = metaColList[i];
            if (metaCol.secret) {
                backList.push(metaCol);
            } else {
                foreList.push(metaCol);
            }
        }
        return foreList.concat(backList);
    }

    //过滤国定列（限制数量，如果超过返回 true）
    function filterFixedColCount(colConfList, limitCount) {
        if (limitCount < 0) {
            return false;
        }
        let limitExceeded = false;
        //
        colConfList = colConfList || [];
        let foundCount = 0;
        let colConf = null;
        for (let i = 0, c = colConfList.length; i < c; i++) {
            colConf = colConfList[i];
            if (colConf.fixed) {
                foundCount++;
                if (foundCount > limitCount) {
                    limitExceeded = true;
                    colConf.fixed = false;
                }
            }
        }
        //
        return limitExceeded;
    }

    function isValidColConf(colConf) {
        let valid = true;
        if (colConf == null) {
            valid = false;
        } else {
            if (colConf.name == null || colConf.name.trim() == '') {
                valid = false;
            } else if (colConf.text == null || colConf.text.trim() == '') {
                valid = false;
            } else if (colConf.dataType == null || colConf.dataType.trim() == '') {
                valid = false;
            }
        }
        return valid;
    }

    function makePropListForDynaTag(colConf) {
        let propList = [];
        //
        if (colConf.dynaTag == true) {
            propList.push({
                label: '参考位置',
                code: 'tagMetaRole',
                inputType: 'Single',
                valueType: 'Integer',
                asDropdown: true,
                dataList: makeTagMetaRoleList(),
                value: colConf.tagMetaRole || null
            });
            propList.push({
                label: '参考表名',
                code: 'tagMetaTableName',
                inputType: 'Text',
                valueType: 'String',
                value: colConf.tagMetaTableName || null
            });
        }

        return propList;
    }

    //
    const confHeaderHeight = 34;
    export default {
        components: {SwbPropEditor, SwbDtPopover},
        name: 'swb-result-col-conf',
        desc: '结果列信息配置',
        //
        custTag: 'ResultColConf',//自定义属性（用于自定义判断）
        //
        props: {
            viewMode: {
                type: Boolean,
                default: false
            },
            userMode: {//用户模式：0: 开发模式, 1: 运营模式，2：用户模式
                type: Number,
                default: 2
            },
            //是否为历史查询
            forHisQry: {
                type: Boolean,
                default: false
            },
            //历史表名（仅供历史查询设计用）
            hisTblName: {
                type: String,
                default: null
            },
            showAsTpl: {//是否显示按模板信息选项
                type: Boolean,
                default: false
            },
            title: {//头部标题
                type: String,
                default: '结果列设置'
            },
            showExtBtns: {//是否显示关闭按钮
                type: Boolean,
                default: false
            },
            onPreviewConf: {//预览配置效果回调函数
                type: Function,
                default: null
            },
            custSavable: {//自定义信息是否可以保存
                type: Boolean,
                default: false
            },
            onSaveCustConf: {//保存自定义调整处理函数
                type: Function,
                default: null
            },
            onConfirm: {//应用按钮处理函数
                type: Function,
                default: null
            },
            onClose: {//关闭按钮处理函数
                type: Function,
                default: null
            },
            //
            fixedColAllowed: {//允许的固定列数量( <0 : 不限制）
                type: Number,
                default: -1
            },
            metaColList: {//原始的列信息{name, text, dataType, format, tooltip, secret, percent, linkFuncExpr, width, align, overflowAsTip, hidden, fixed}
                type: Array,
                default: function () {
                    return [];
                }
            },
            custColList: {//自定义列信息{name, title, group, width, align, overflowAsTip, hidden, fixed}
                type: Array,
                default: function () {
                    return [];
                }
            },
            height: {//指定的高度
                default: 0
            }
        },
        //
        data() {
            return {
                theVRowId: null,
                rowItemKey: 'name',
                //
                instantKeyword: '', //及时关键字
                delayedKeyword: '', //延迟关键字
                //
                minColWidth: null,
                //
                maxHeight: 0,
                gridHeight: '100%',
                //
                gridTable: null,
                //
                tooltipDelayMs: 1000,
                //
                curColTooltip: '',
                colTipMaxLength: 250,
                colTipAutoSize: {minRows: 4, maxRows: 10},
                //
                curEnumMap: '',
                //
                metaColListInner: [],
                custColListInner: [],
                //
                formData: {
                    colConfRows: [],
                    //
                    hiddenText: '隐藏',
                    visibleText: '可见'
                },
                //
                dynaTagEditorVisible: false,
                dynaTagEditor: {
                    width: 400,
                    widthForLabel: 120,
                    showBtnBar: true,
                    viewMode: false,
                    readOnly: false,
                    //
                    name: null,
                    title: '动态标签配置信息',
                    propList: [],
                    extra: null
                }
            };
        },
        watch: {
            userMode(newVal, oldVal) {
                this.rowItemKey = this.userMode == 0 ? this.theVRowId.name() : 'name';
                //
                this.init();
            },
            metaColList(newVal, oldVal) {
                this.metaColListInner = Utils.merge([], this.metaColList);
                this.custColListInner = [];
                //
                this.init();
            },
            custColList(newVal, oldVal) {
                this.custColListInner = Utils.merge([], this.custColList);
                //
                this.init();
            },
            height(newVal, oldVal) {
                this.setHeights();
            }
        },
        created() {
            this.theVRowId = VRowId.newOne().name('_row_id_');
            //
            this.rowItemKey = this.userMode == 0 ? this.theVRowId.name() : 'name';
            //
            this.metaColListInner = Utils.merge([], this.metaColList);
            this.custColListInner = Utils.merge([], this.custColList);
        },
        //
        mounted() {
            this.gridTable = this.$refs['gridTable'];
            this.gridTableWrapper = $(this.$el).find('>[name="confForm"]');
            //
            this.init();
            //
            this.setHeights();
        },
        beforeDestroy() {
            //ctrl
            this.gridTable = null;
            this.gridTableWrapper = null;
            this.dynaTagEditor = null;
            //data
            this.formData = null;
            this.metaColListInner = null;
            this.custColListInner = null;
            this.colTipAutoSize = null;
        },
        destroyed() {
            this.theVRowId = null;
        },
        //
        methods: {
            //返回推拽信息（注意绑定表达式写法：v-row-draggable="makeDragCtxData()"）
            makeDragCtxData() {
                return {
                    //函数调用上下文
                    context: this,
                    //数据提供者（基于 context 调用，可以使用 this）
                    provider: function () {
                        //返回 null 或 false 代表不允许拖拽
                        return this.formData.colConfRows || [];
                    },
                    //数据变更回调函数（基于 context 调用，可以使用 this）
                    callback: function (dataList, newIndex) {
                        //console.log(dataList);
                        //console.log('条目已经移动到第 ' + (newIndex + 1) + ' 行');
                        this.$set(this.formData, 'colConfRows', dataList);
                        //
                        this.$nextTick(function () {
                            this.gridTable.setCurrentRow(dataList[newIndex]);
                        });
                    }
                };
            },
            setHeights() {
                let gridHeight = this.gridHeight = this.getGridHeight();
                this.gridTableWrapper.height(gridHeight);
                //
                this.gridTable.doLayout();
            },
            setMaxHeight(maxHeight) {
                this.maxHeight = maxHeight || 0;
                //
                this.setHeights();
            },
            getGridHeight() {
                let extraHeight = confHeaderHeight; //头部固定高度
                let newHeight = this.calcGridHeight(this.gridTable, this.height, this.maxHeight, extraHeight);
                //console.debug('newHeight :' + newHeight);
                return newHeight;
            },
            calcGridHeight(gridTable, height, maxHeight, extraHeight = 0) {
                height = height || 0;
                let heightGiven = typeof height == 'number' && height > 0;
                if (heightGiven) {
                    height = Math.max(height, extraHeight);
                }
                maxHeight = maxHeight || 0;
                let gridHeight = height || '100%';
                let needHeight = getElTableHeight(gridTable);
                if (maxHeight > 0) {//限定最大高度
                    maxHeight = Math.max(maxHeight, extraHeight);
                    if (needHeight + extraHeight > maxHeight) {//不超过最大高度
                        gridHeight = maxHeight - extraHeight;
                    } else {
                        let adjusted = false;
                        if (heightGiven) {//同时指定了高度
                            height = Math.min(height, maxHeight);
                            if (needHeight + extraHeight < height) {//不低于指定高度
                                gridHeight = height - extraHeight;
                                adjusted = true;
                            }
                        }
                        if (!adjusted) {//未指定高度，自动伸缩
                            gridHeight = needHeight;
                        }
                    }
                } else {//仅指定了高度
                    if (heightGiven) {
                        gridHeight = height - extraHeight;
                    }
                }
                return gridHeight;
            },
            getDataTypeName(dataType) {
                return dataTypeNameMap[dataType] || '字符串'
            },
            isFormattable(dataType) {
                return dataType && (dataType.isIn('float', 'integer', 'date', 'bool'));
            },
            getColWidthHint() {//列宽提示
                let hint = '留空';
                if (this.minColWidth != null && this.minColWidth > 0) {
                    hint += ' 或 小于 ' + this.minColWidth;
                }
                hint += ' 将被视为 自动列宽';
                return hint;
            },
            isDiffTitle(colIndex) {
                if (this.userMode < 1) {
                    return;
                } else {
                    let colConfRows = this.formData.colConfRows;
                    let colConf = colConfRows[colIndex];
                    if (colConf.secret) {
                        return false;
                    }
                    let custTitle = (colConf.title || '').trim();
                    if (this.userMode == 1) {
                        return custTitle != '' && custTitle != colConf.text;
                    } else {//2
                        let metaTitle = colConf.metaTitle || colConf.text || '';//dont trim !!!
                        return custTitle != '' && custTitle != metaTitle;
                    }
                }
            },
            isDiffGroup(colIndex) {
                if (this.userMode < 2) {
                    return false;
                }
                let colConfRows = this.formData.colConfRows;
                let colConf = colConfRows[colIndex];
                if (colConf.secret) {
                    return false;
                }
                let metaGroup = colConf.metaGroup || '';
                let custGroup = colConf.group || '';
                return custGroup != '' && custGroup != metaGroup;
            },
            getTableRowClassName({row, rowIndex}) {
                let classNames = [];
                //
                if (this.userMode == 0) {//增加过滤隐藏class
                    let keyword = (this.delayedKeyword || '').trim();
                    if (keyword.length > 0) {
                        //忽略大小写匹配
                        keyword = keyword.toLowerCase();

                        let filterOk = false;
                        let tempStr = row.name || '';
                        if (tempStr.toLowerCase().indexOf(keyword) != -1) {
                            filterOk = true;
                        }

                        if (!filterOk) {
                            tempStr = row.text || '';
                            if (tempStr.toLowerCase().indexOf(keyword) != -1) {
                                filterOk = true;
                            }
                        }
                        //
                        if (!filterOk) {
                            classNames.push('filter-hidden');
                        }
                    }
                }

                if (row.fixed) {
                    classNames.push('fixed-col');
                }
                if (row.hidden) {
                    classNames.push('hidden-col');
                }
                if (row.secret) {
                    classNames.push('secret-col');
                    if (this.userMode < 2) {
                        if (classNames.indexOf('filter-hidden') == -1) {
                            classNames.push('inner-mode');
                        }
                    }
                }
                if (row.name == null || row.name.trim() == '') {
                    classNames.push('invalid-name');
                }
                if (row.text == null || row.text.trim() == '') {
                    classNames.push('invalid-text');
                }
                if (row.dataType == null || row.dataType.trim() == '') {
                    classNames.push('invalid-dataType');
                }
                return classNames.join(' ');
            },
            init(metaColList = null) {
                if (metaColList != null) {//完全重新替换
                    this.metaColListInner = Utils.merge([], metaColList);
                    this.custColListInner = [];//清空
                } else if (this.userMode < 2) {//非用户模式忽略自定义
                    this.custColListInner = [];
                }
                //
                let colConfRows = this.userMode == 2 ? reserveMergeColArray(this.custColListInner, this.metaColListInner, 'name') : this.metaColListInner;
                //重排私密列在后
                colConfRows = arrangeColList(colConfRows);
                //数据调整
                colConfRows.forEach(function (item) {
                    if (item.secret) {//私密字段强制隐藏
                        item.hidden = true;
                    }
                    if (item.hidden) {
                        item.fixed = false;
                        item.title = null;
                        item.group = null;
                    }
                    if (item.fixed) {
                        item.group = null;
                    }
                    item.overflowAsTip = item.overflowAsTip || false;
                    item.align = item.align || getColDefAlign(item);
                    item.format = item.format || getColDefFormat(item);
                    item.asTpl = item.asTpl || false;
                    //
                    item.width = Utils.ParseInt(item.width);
                });
                //
                filterFixedColCount(colConfRows, this.fixedColAllowed);
                //
                if (this.rowItemKey == this.theVRowId.name()) {
                    this.theVRowId.setIds(colConfRows);
                } else {
                    this.theVRowId.delIds(colConfRows);
                }
                //
                this.formData.colConfRows = colConfRows;
                //
                let self = this;
                setTimeout(function () {
                    if (self.gridTable != null) {
                        self.gridTable.doLayout();
                    }
                }, 500);
            },
            clearMetaCols() {
                if (this.userMode == 0) {
                    this.init([]);
                }
            },
            moveColPosition(colName, colIndex, where) {
                console.debug(colName, colIndex, where);
                let colConfRows = this.formData.colConfRows.clone();
                //
                if (where == 'prev') {
                    if (colIndex == 0) {
                        return;//最前一个
                    }
                    if (colIndex > 0) {
                        //禁止私密列往非私密列前移动
                        let currRow = colConfRows[colIndex];
                        let prevRow = colConfRows[colIndex - 1];
                        if (currRow.secret && !prevRow.secret) {
                            return;
                        }
                    }
                } else {//next
                    if (colIndex == colConfRows.length - 1) {
                        return;//最后一个
                    }
                    if (colIndex < colConfRows.length - 1) {
                        //禁止非私密列往私密列后移动
                        let currRow = colConfRows[colIndex];
                        let nextRow = colConfRows[colIndex + 1];
                        if (!currRow.secret && nextRow.secret) {
                            return;
                        }
                    }
                }
                colConfRows.move([colIndex], where);
                this.formData.colConfRows = colConfRows;
                //标记新行
                colIndex = colConfRows.indexOf(colName, function (item, name) {
                    return item.name == name;
                });
                let target = colConfRows[colIndex];
                this.gridTable.setCurrentRow(target);
            },
            deleteMetaCol(colIndex) {
                if (this.userMode == 0) {
                    let colConfRows = this.formData.colConfRows.clone();
                    colConfRows.removeAt(colIndex);
                    this.formData.colConfRows = colConfRows;
                }
            },
            //新增配置列
            addMetaCol() {
                if (this.userMode == 0) {
                    let colConfRows = this.formData.colConfRows;
                    let colConf = {
                        name: '',
                        text: '',
                        dataType: '',
                        width: '',
                        align: 'left'
                    };
                    //
                    this.theVRowId.setId(colConf);
                    //
                    colConfRows.push(colConf);
                    //
                    this.init(colConfRows);
                }
            },
            filterList() {
                //利用change事件避免频繁模型的值频繁触发事件
                this.delayedKeyword = this.instantKeyword;
            },
            appendByCols(selCols) {
                if (this.userMode > 0) {
                    return;
                }
                //
                selCols = selCols || [];
                if (selCols.length > 0) {
                    let colConfRows = this.formData.colConfRows;
                    for (let i = 0, c = selCols.length; i < c; i++) {
                        let tmpCol = selCols[i];
                        let colConf = {
                            name: tmpCol.columnName,
                            text: tmpCol.comment,
                            dataType: '',
                            width: Math.min(tmpCol.charMaxLength * 10, 200),
                            align: '',
                            format: ''
                        };
                        let javaType = tmpCol.javaType;
                        if (javaType == 'java.sql.Time') {
                            colConf.dataType = 'date';
                            colConf.format = 'HH:mm:ss';
                            colConf.align = 'center';
                        } else if (javaType == 'java.sql.Timestamp') {
                            colConf.dataType = 'date';
                            colConf.format = 'yyyy-MM-dd HH:mm:ss';
                            colConf.align = 'center';
                        } else if (javaType == 'java.sql.Date' || javaType == 'java.util.Date') {
                            colConf.dataType = 'date';
                            colConf.format = 'yyyy-MM-dd';
                            colConf.align = 'center';
                        } else {
                            //转为简单名称
                            let dotIndex = javaType.lastIndexOf('.');
                            javaType = dotIndex == -1 ? javaType : javaType.substring(dotIndex + 1);
                            if (javaType.isIn('Long', 'Short', 'Byte')) {
                                javaType = 'Integer';
                            } else if (javaType.isIn('Double', 'BigDecimal')) {
                                javaType = 'Float';
                            }
                            colConf.valueType = javaType;
                            if (javaType == 'Boolean') {
                                colConf.dataType = 'bool';
                                colConf.format = '是/否';
                                colConf.align = 'center';
                            } else if (javaType == 'Integer') {
                                colConf.dataType = 'integer';
                                colConf.align = 'right';
                            } else if (javaType == 'Float') {
                                colConf.dataType = 'float';
                                colConf.format = '0.00';
                                colConf.align = 'right';
                            } else {
                                colConf.dataType = 'string';
                                colConf.align = 'left';
                                if (tmpCol.charMaxLength * 10 > 220) {
                                    colConf.overflowAsTip = true;
                                }
                            }
                        }
                        //
                        this.theVRowId.setId(colConf);
                        //
                        colConfRows.append(colConf);
                    }
                    //
                    this.init(colConfRows);
                }
            },
            appendFromCols() {
                let hisTblName = this.hisTblName;
                if (Utils.isNoB(hisTblName)) {
                    Toast.show('未指定库表，操作无法继续', 5000, 'warning');
                    return;
                }
                //
                let iniSelected = [];
                //当前存在的
                let colConfRows = this.formData.colConfRows;
                colConfRows.forEach(function (confRow) {
                    let name = (confRow.name || '').trim();
                    if (name) {
                        iniSelected.push(name);
                    }
                });
                //
                let self = this;
                showDbColSelectDlg({
                    tableName: hisTblName,
                    iniSelected: iniSelected
                }, function (selectedCols) {
                    console.log(selectedCols);
                    self.appendByCols(selectedCols);
                });
            },
            inputJsonConf() {
                let metaColList = this.getMetaColList() || [];
                //
                let self = this;
                Vue.$showDialog({
                    title: '输入json配置 - meta colList',
                    width: 800,//80%
                    height: -100,//80%
                    showCloseBtn: false,
                    centerButtons: true,
                    //
                    template: '<swb-code-editor style="width:740px;height:100%;margin:0;" language="json" v-model="content" ></swb-code-editor>',
                    data: {content: JSON.format(metaColList)},

                    okClicked: function () {
                        let jsonModel = (this.content || '').trim();
                        console.debug(jsonModel);
                        let metaColList = [];
                        try {
                            metaColList = JSON.decode(jsonModel)
                        } catch (ex) {
                            //console.warn(ex);
                        }
                        if (metaColList.length < 1) {
                            this.$message({
                                type: 'warning',
                                message: 'json 数组模型无效'
                            });
                            return false;
                        }
                        //
                        self.resetMetaColList(metaColList);
                    }
                });
            },
            previewTheConf() {
                let metaColList = this.getMetaColList();
                console.debug(metaColList);
                let custColList = this.getCustColList(true);
                console.debug(custColList);
                //
                if (this.onPreviewConf) {
                    this.onPreviewConf();
                } else {
                    console.warn('未设置 onPreviewConf 事件处理函数')
                }
            },
            handleSaveCustConf() {
                if (this.onSaveCustConf) {
                    this.onSaveCustConf();
                } else {
                    console.warn('未设置 onSaveCustConf 事件处理函数')
                }
            },
            handleConfirm() {
                if (this.onConfirm) {
                    this.onConfirm();
                } else {
                    console.warn('未设置 onConfirm 事件处理函数')
                }
            },
            //
            handleClose() {
                if (this.onClose) {
                    this.onClose();
                } else {
                    console.warn('未设置 onClose 事件处理函数')
                }
            },
            bttopFixedCols() {
                let colConfRows = this.formData.colConfRows.clone();
                this.formData.colConfRows = colConfRows.split(function (item) {
                    return item.fixed == true ? 0 : 1;
                }, true).flatten();
            },
            //
            filterColWidth(colConf, colIndex) {
                let width = colConf.width || null;
                width = Utils.ParseInt(width) || '';
                colConf.width = width;
                this.$set(this.formData.colConfRows, colIndex, Utils.merge(colConf));
            },
            //
            showColTipEditor(event, colIndex) {
                let targetBtn = event.currentTarget;
                //
                let colConfRows = this.formData.colConfRows;
                let colConf = colConfRows[colIndex];
                //console.debug(colConf);
                //
                this.curColTooltip = colConf.tooltip || '';
                //
                let colTipPopover = this.$refs['colTipPopover'];
                colTipPopover.bindToReferer(targetBtn, 'click', {
                    showNow: true,
                    placement: 'left-start',
                    tag: colIndex
                });
            },
            doColTipConfirm() {
                let colTipPopover = this.$refs['colTipPopover'];
                colTipPopover.hide();
                let colIndex = colTipPopover.getTag();
                let tooltip = (this.curColTooltip || '').trim();
                //console.debug(tooltip);
                let colConfRows = this.formData.colConfRows;
                let colConf = colConfRows[colIndex];
                colConf.tooltip = tooltip;
                this.$set(colConfRows, colIndex, colConf);
            },
            doColTipCancel() {
                let colTipPopover = this.$refs['colTipPopover'];
                colTipPopover.hide();
            },
            //
            showEnumMapEditor(event, colIndex) {
                let targetBtn = event.currentTarget;
                //
                let colConfRows = this.formData.colConfRows;
                let colConf = colConfRows[colIndex];
                //console.debug(colConf);
                //
                this.curEnumMap = colConf.enumMap || '';
                //
                let enumMapPopover = this.$refs['enumMapPopover'];
                enumMapPopover.bindToReferer(targetBtn, 'click', {
                    showNow: true,
                    placement: 'left-start',
                    tag: colIndex
                });
            },
            doEnumMapConfirm() {
                let enumMapPopover = this.$refs['enumMapPopover'];
                enumMapPopover.hide();
                let colIndex = enumMapPopover.getTag();
                let enumMap = (this.curEnumMap || '').trim();
                console.debug(enumMap);
                let colConfRows = this.formData.colConfRows;
                let colConf = colConfRows[colIndex];
                colConf.enumMap = enumMap;
                this.$set(colConfRows, colIndex, colConf);
            },
            doEnumMapCancel() {
                let enumMapPopover = this.$refs['enumMapPopover'];
                enumMapPopover.hide();
            },
            //
            syncFixedColConf(colConf, colIndex) {
                let fixed = colConf.fixed || false;
                if (fixed) {
                    let limitExceeded = filterFixedColCount(this.formData.colConfRows, this.fixedColAllowed);
                    if (limitExceeded) {
                        this.formData.colConfRows = this.formData.colConfRows.clone();
                        //
                        if (this.fixedColAllowed == 0) {
                            this.$message({
                                message: '不允许结果有固定列',
                                type: 'warning'
                            });
                        } else {
                            this.$message({
                                message: '结果最多只能有 ' + this.fixedColAllowed + ' 个固定列',
                                type: 'warning'
                            });
                        }
                    } else {
                        colConf.group = null;
                        this.$set(this.formData.colConfRows, colIndex, Utils.merge(colConf));
                    }
                }
            },
            syncHiddenColConf(colConf, colIndex) {
                let hidden = colConf.hidden || false;
                if (hidden) {
                    colConf.fixed = false;
                    colConf.title = null;
                    colConf.group = null;
                    this.$set(this.formData.colConfRows, colIndex, Utils.merge(colConf));
                }
            },
            syncSecretColConf(colConf, colIndex) {
                let secret = colConf.secret || false;
                if (secret) {
                    colConf.hidden = true;
                    colConf.fixed = false;
                    colConf.title = null;
                    colConf.group = null;
                }
                this.formData.colConfRows = arrangeColList(this.formData.colConfRows);
            },
            //
            setMinColWidth(minColWidth) {
                this.minColWidth = Utils.ParseInt(minColWidth);
            },
            //同步/设置自定义列宽度
            setCustColWidth(colName, colWidth) {
                let colConfRows = this.formData.colConfRows;
                //
                let colIndex = colConfRows.indexOf(colName, function (item, name) {
                    return item.name == name;
                });
                if (colIndex != -1) {
                    let target = colConfRows[colIndex];
                    target.width = colWidth;
                    //
                    this.$set(this.formData.colConfRows, colIndex, target);
                    //
                    this.gridTable.setCurrentRow(target);
                }
            },
            //
            //
            syncDynaTagEditorVisible(visible) {
                this.dynaTagEditorVisible = visible;
            },
            //只有Select && Integer的才能作为动态标签列
            mayBeDynaTagField(colConf, colIndex) {
                return colConf.dataType == 'integer';
            },
            showDynaTagEditor(event, colIndex) {
                let targetBtn = event.currentTarget;
                //formData.colConfRows
                let colConfRows = this.formData.colConfRows;
                let colConf = colConfRows[colIndex];
                console.debug(colConf);

                let propList = makePropListForDynaTag(colConf);
                //
                let dynaTagEditor = this.dynaTagEditor;
                this.$set(dynaTagEditor, 'name', colConf.name);
                this.$set(dynaTagEditor, 'title', '【' + (colConf.text || colConf.name) + '】标签配置');
                this.$set(dynaTagEditor, 'propList', propList);
                this.$set(dynaTagEditor, 'extra', colIndex);
                //
                let dynaTagPopover = this.$refs['dynaTagPopover'];
                dynaTagPopover.bindToReferer(targetBtn, 'click', {
                    showNow: true,
                    placement: 'left-start'
                });
            },
            onDynaTagEditorConfirm(name, propValues, extra, editor) {
                let colIndex = extra;
                //console.debug(colIndex);
                //console.debug(propValues);
                this.dynaTagEditorVisible = false;
                //
                let colConfRows = this.formData.colConfRows;
                let colConf = colConfRows[colIndex];
                Utils.merge(colConf, propValues);
                this.$set(colConfRows, colIndex, colConf);
            },
            onDynaTagEditorCancel(name, extra, editor) {
                let colIndex = extra;
                //console.debug(colIndex);
                this.dynaTagEditorVisible = false;
            },
            //===================================== 公开方法 =======================================
            //重置元列列表
            resetMetaColList(metaColList = []) {
                this.init(metaColList);
            },
            //获取自定义配置（仅包含自定义部分）
            getCustColList(debugOnly) {
                let colConfRows = this.formData.colConfRows;
                //过滤无效的
                colConfRows = colConfRows.filter(function (colConf) {
                    return isValidColConf(colConf);
                });
                //
                return this.userMode == 2 || debugOnly ? colConfRows.map(function (item) {
                    item.name = item.name.trim();
                    //
                    return extractCustColInfo(item);
                }) : [];
            },
            //获取定义的列配置信息（全息）
            getMetaColList() {
                let colConfRows = this.formData.colConfRows;
                //
                colConfRows = Utils.merge([], colConfRows);
                //过滤无效的
                colConfRows = colConfRows.filter(function (colConf) {
                    return isValidColConf(colConf);
                });
                //数据调整
                let theVRowId = this.theVRowId;
                let userMode = this.userMode;
                colConfRows.forEach(function (item) {
                    item.name = item.name.trim();
                    if (item.title != null) {
                        item.title = item.title.trim();
                    }
                    if (userMode < 2) {
                        if (item.group != null) {
                            item.group = item.group.trim();
                        }
                    }
                    if (item.dataType !== 'integer') {
                        delete item['enumMap'];
                    }
                    //动态标签字段
                    if (!item.dynaTag) {
                        delete item['tagMetaRole'];
                        delete item['tagMetaTableName'];
                    }
                    //
                    theVRowId.delId(item);
                    //
                    item.width = Utils.ParseInt(item.width);
                });
                //
                return colConfRows;
            },
            //清除配置信息
            clear() {
                this.formData.colConfRows = [];
            }
        }
    }

</script>

<style>
    .result-col-form .el-table table tbody tr.filter-hidden {
        display: none;
    }

    .result-col-form .el-table__body tr.fixed-col > td {
        background-color: #FDF5E6 !important;
    }

    .result-col-form .el-table__body tr.hidden-col > td,
    .result-col-form .el-table__body tr.hidden-col > td input,
    .result-col-form .el-table__body tr.hidden-col > td select {
        font-style: italic;
        color: #AAAAAA !important;
    }

    .result-col-form .el-table__body tr.invalid-name > td .col-name input {
        border: 1px dashed red;
    }

    .result-col-form .el-table__body tr.invalid-text > td .col-text input {
        border: 1px dashed red;
    }

    .result-col-form .el-table__body tr.invalid-dataType > td .col-dataType input {
        border: 1px dashed red;
    }

    .result-col-form .el-table__body tr > td .col-width input, .el-table__body tr > td input.col-format {
        text-align: right;
    }

    .result-col-form .el-table__body tr > td .col-title.diff input, .el-table__body tr > td input.col-group.diff {
        border-bottom: 1px solid darkgreen;
    }

    .el-table__body tr > td input.col-group:disabled {
        background-color: #F5F7FA;
        border-color: #E4E7ED;
        color: #C0C4CC;
        cursor: not-allowed;
    }

    .result-col-form .el-table__body tr.hidden-col.secret-col {
        display: none;
    }

    .result-col-form .el-table__body tr.hidden-col.secret-col.inner-mode {
        display: table-row;;
    }

    .result-col-form .el-table__body tr.hidden-col.secret-col.inner-mode > td {
        font-weight: bold;
        background-color: #cfcfcf !important;
    }

    .result-col-form .el-table__fixed-right::before, .el-table__fixed::before {
        background-color: transparent;
    }

    .result-col-form .el-table__header .col-title-tooltip-wrapper {
        float: right;
        height: 100%;
        margin-right: -2px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/query/ResultColConf.vue